import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { getAllZorMembers } from '@/actions/zor-member/getAllZorMembers';
import { ApiResponse } from '@/types/response.type';
import { PaginatedZorMembers } from '@/types/zor.member.type';

export interface UseGetAllZorMembersParams {
  page?: number;
  limit?: number;
}

export interface UseGetAllZorMembersReturn {
  result: ApiResponse<PaginatedZorMembers> | undefined;
  error: Error | null;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  isRefetching: boolean;
}

export const useGetAllZorMembers = (
  params: UseGetAllZorMembersParams = {}
): UseGetAllZorMembersReturn => {
  const { page = 1, limit = 10 } = params;

  const query: UseQueryResult<
    ApiResponse<PaginatedZorMembers> | undefined,
    Error
  > = useQuery({
    queryKey: ['zor-members', page, limit],
    queryFn: () => getAllZorMembers({ page, limit }),
  });

  return {
    result: query.data,
    error: query.error,
    isError: query.isError,
    isSuccess: query.isSuccess,
    isLoading: query.isPending,
    isRefetching: query.isRefetching,
  };
};
